











































































import Vue from 'vue'
import { Table, TableColumn, Button } from 'element-ui'
import ClipLoader from '@/components/vue-spinner/ClipLoader.vue'
import './ClipOverview.scss'
import { Cast } from '@/types/casts'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'
import subscribeArchiverQueue from '@/mixins/SubscribeArchiverQueue'
import helpers from '@/helpers'
import { KeyDict } from '@/types'
import { ArchiverTask } from '@/store/types'

interface ClipRow {
  name: string,
  url?: string,
  start: string,
  end: string,
  duration: string,
  deletable: boolean,
  archivingText: string
}

export default Vue.extend({
  name: 'ClipOverview',
  mixins: [subscribeArchiverQueue],
  props: {
    cast: {
      type: Object as () => Cast,
      required: true
    },
    videoduration: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    trim: [ 0, 10 ],
    videoLength: 0,
    adjusted: 0
  }),
  methods: {
    secondsToString (val: number): string {
      const hours = Math.floor(val / 3600)
      const minutes = Math.floor((val / 60 - hours * 60))
      const seconds = Math.floor(val - (hours * 3600 + minutes * 60))
      let output = ''
      if (hours < 10) {
        output += '0'
      }
      output += hours + ':'
      if (minutes < 10) {
        output += '0'
      }
      output += minutes + ':'
      if (seconds < 10) {
        output += '0'
      }
      output += seconds
      return output
    },
    download (url: string) {
      window.open(url, '_blank')
    },
    rowStyle (params: { row: ClipRow }): Partial<CSSStyleDeclaration> {
      if (params.row.name === 'Full Length Output') {
        return { backgroundColor: 'rgb(167, 79, 71)' }
      }
      return {}
    },
    remove (clipid: string) {
      this.$confirm('Are you sure you want to delete this clip?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$emit('deleteClip', clipid)
        this.$message({
          type: 'success',
          message: 'Clip has been deleted'
        })
      }).catch(() => {
        //
      })
    },
    archivingProgressText (castId: string, archivingItemId: string): string {
      const castArchiveTask = this.archiverQueue[castId]
      if (castArchiveTask === undefined) return ''
      for (const [itemId, queueItem] of Object.entries(castArchiveTask)) {
        if (itemId === archivingItemId || (archivingItemId === 'full' && itemId.startsWith('full'))) {
          return helpers.getProgressText(queueItem.progress_pct)
        }
      }
      return ''
    }
  },
  components: {
    'el-table': Table,
    'el-table-column': TableColumn,
    'el-button': Button,
    'clip-loader': ClipLoader
  },
  computed: {
    canReadArchive (): boolean {
      return this.$can(AbilityAction.Read, AbilitySubject.Archive)
    },
    canDeleteArchive (): boolean {
      return this.$can(AbilityAction.Delete, AbilitySubject.Archive)
    },
    clips (): ClipRow[] {
      const full = {
        name: 'Full Length Output',
        url: this.cast.mp4,
        start: this.secondsToString(0),
        end: this.secondsToString(this.videoduration),
        duration: this.secondsToString(this.videoduration),
        deletable: false,
        archivingText: this.archivingProgressText(this.cast.id, 'full')
      }
      if (this.videoduration === 0) {
        full.end = 'calculating ...'
        full.duration = 'calculating ...'
      }
      const arr: ClipRow[] = [full]
      const clips = this.cast.clips
      if (clips !== undefined) {
        Object.keys(clips).forEach(clipid => {
          const clip = clips[clipid]
          const clipData = {
            id: clipid,
            name: clip.name,
            start: this.secondsToString(clip.start),
            end: this.secondsToString(clip.end),
            duration: this.secondsToString(clip.end - clip.start),
            url: clip.url,
            deletable: clip.url !== 'running',
            archivingText: this.archivingProgressText(this.cast.id, clipid)
          }
          if (clip.deleted !== true) {
            arr.push(clipData)
          }
        })
      }
      const isos = this.cast.isos
      if (isos !== undefined) {
        Object.keys(isos).forEach(ingestid => {
          const ingest = isos[ingestid]
          const clipData = {
            id: ingestid,
            name: ingest.name,
            start: this.secondsToString(ingest.start),
            end: this.secondsToString(ingest.end),
            duration: this.secondsToString(ingest.end - ingest.start),
            url: ingest.url,
            deletable: false,
            archivingText: this.archivingProgressText(this.cast.id, ingestid)
          }
          arr.push(clipData)
        })
      }
      return arr
    },
    archiverQueue (): KeyDict<ArchiverTask> {
      return this.$store.direct.state.opsmonitor.archiverQueue
    }
  }
})
